export default __webpack_public_path__ + "static/media/V344_RoHS.044a4f74.pdf";